// Checks if the given value is a part of the enum's values
export function isInEnum(enumObj: object, value: string | number): boolean {
  return Object.values(enumObj).includes(value)
}
